export const paymentActionTypes = {
  START_CREATE_PAYMENT_PAGE: "START_CREATE_PAYMENT_PAGE",
  CREATE_PAYMENT_PAGE_SUCCESS: "CREATE_PAYMENT_PAGE_SUCCESS",
  CREATE_PAYMENT_PAGE_FAILURE: "CREATE_PAYMENT_PAGE_FAILURE",

  START_GET_PAYMENT_TOKEN: "START_GET_PAYMENT_TOKEN",
  GET_PAYMENT_TOKEN_SUCCESS: "GET_PAYMENT_TOKEN_SUCCESS",
  GET_PAYMENT_TOKEN_FAILURE: "GET_PAYMENT_TOKEN_FAILURE",
};
